import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';
import { normalizeCollectedBossMetadata } from '../domain/raidBossMetadata.js';

function requireClient() {
  if (!hasSupabaseConfig || !supabase) throw new Error('서비스 연결 설정을 확인할 수 없습니다.');
  return supabase;
}

export async function saveCollectedRaidBossMetadata({ seasonNo, bosses }) {
  const targetSeasonNo = Number(seasonNo);
  if (!Number.isInteger(targetSeasonNo) || targetSeasonNo < 1 || targetSeasonNo > 9999) throw new Error('invalid_season_no');
  const payload = normalizeCollectedBossMetadata(bosses);
  if (!payload.length) return { updatedCount: 0, bosses: [] };

  const { data, error } = await requireClient().rpc('sync_union_raid_boss_metadata', {
    target_season_no: targetSeasonNo,
    bosses_payload: payload.map((boss) => ({
      boss_no: boss.bossNo,
      boss_name: boss.bossName,
      element: boss.element,
      boss_id: boss.bossId || null,
      icon_id: boss.iconId || null,
      monster_model_id: boss.monsterModelId || null,
    })),
  });
  if (error) {
    const next = new Error(String(error.message || '보스 정보를 저장하지 못했습니다.'));
    next.code = error.code || 'boss_metadata_sync_failed';
    throw next;
  }
  return {
    updatedCount: Number(data?.updated_count || 0),
    bosses: Array.isArray(data?.bosses) ? data.bosses : [],
  };
}
